import React from 'react';
import { User, Phone, Bike } from 'lucide-react';

const OrdersDriverModal = ({ deliveryDrivers, handleSelectDriver, notifyingDriver, pendingDeliveryOrder, setPendingDeliveryOrder, setShowDriverModal }) => {
  return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
          <div className="bg-gray-800 rounded-xl w-full max-w-sm border border-purple-500/30 shadow-xl animate-in fade-in zoom-in duration-200">
            <div className="p-4 border-b border-gray-700 flex items-center gap-3">
              <div className="p-2 bg-purple-500/20 rounded-full">
                <Bike className="w-5 h-5 text-purple-400" />
              </div>
              <div>
                <h3 className="text-white font-semibold">Selecionar Entregador</h3>
                <p className="text-gray-400 text-xs">Pedido #{pendingDeliveryOrder?.order_number || pendingDeliveryOrder?.id?.slice(0, 8)}</p>
              </div>
            </div>
            
            <div className="p-4 space-y-2 max-h-64 overflow-y-auto">
              {deliveryDrivers.map((driver) => (
                <button
                  key={driver.id}
                  onClick={() => handleSelectDriver(driver)}
                  disabled={notifyingDriver}
                  className="w-full p-3 bg-gray-700/50 hover:bg-purple-500/20 border border-gray-600 hover:border-purple-500/50 rounded-lg flex items-center gap-3 transition-all disabled:opacity-50"
                  data-testid={`select-driver-${driver.id}`}
                >
                  <div className="p-2 bg-purple-500/20 rounded-full">
                    <User className="w-4 h-4 text-purple-400" />
                  </div>
                  <div className="flex-1 text-left">
                    <p className="text-white font-medium">{driver.name}</p>
                    <p className="text-gray-400 text-xs flex items-center gap-1">
                      <Phone className="w-3 h-3" />
                      {driver.phone?.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, '($2) $3-$4')}
                    </p>
                  </div>
                  {notifyingDriver && (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-purple-400"></div>
                  )}
                </button>
              ))}
            </div>
            
            <div className="p-4 border-t border-gray-700">
              <button
                onClick={() => {
                  setShowDriverModal(false);
                  setPendingDeliveryOrder(null);
                }}
                className="w-full px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-all"
              >
                Cancelar (não notificar)
              </button>
            </div>
          </div>
        </div>
  );
};

export default OrdersDriverModal;
